import { render, staticRenderFns } from "./MyPageLikedPerformer.vue?vue&type=template&id=13c13c0c&scoped=true&"
import script from "./MyPageLikedPerformer.vue?vue&type=script&lang=js&"
export * from "./MyPageLikedPerformer.vue?vue&type=script&lang=js&"
import style0 from "./MyPageLikedPerformer.vue?vue&type=style&index=0&id=13c13c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c13c0c",
  null
  
)

export default component.exports